/**
 * O letreiro SKYENEX. O E e feito de tres barras e o X e bicolor, entao ele
 * nao e texto simples — e desenhado pelo CSS a partir desta estrutura.
 * Continua como marcacao, e nao imagem, para ficar nitido em qualquer tamanho
 * e acompanhar a cor do fundo onde estiver.
 */
export function Logotype({ grande = false }: { grande?: boolean }) {
  return (
    <span className={`logo__type${grande ? ' logo__type--lg' : ''}`} aria-hidden="true">
      SKY
      <i className="logo__e">
        <b /><b /><b />
      </i>
      NE
      <span className="logo__x">X</span>
    </span>
  )
}
